module.exports = __webpack_public_path__ + "media/images/favicn/safari-pinned-tab-c1bb9f00cac654520b7b7037779f3b13.svg";